import { jsx as c, jsxs as j, Fragment as w } from "react/jsx-runtime";
import b from "react";
import { clsx as z } from "../../utils/clsx.js";
import { noop as p } from "../../utils/functional.js";
import { s as t } from "../../Button.module-Z6njvP9Z.js";
function F(a) {
  const {
    text: e = null,
    icon: l = null,
    decorator: o = null
  } = a;
  return /* @__PURE__ */ j(w, { children: [
    !!l && /* @__PURE__ */ c("span", { className: t["icon-node"], children: l }),
    e,
    !!o && /* @__PURE__ */ c("div", { className: t.decorator, children: o })
  ] });
}
function I(a) {
  const {
    text: e = null,
    icon: l = null,
    theme: o = "default",
    size: s = "normal",
    disabled: f = !1,
    straightCorners: d = !1,
    className: r = "",
    autofocus: u = !1,
    fullWidth: i = !1,
    tabIndex: n
  } = a;
  return z(t.root, t[o], t[s], r, {
    [t.disabled]: f,
    [t.icon]: !!l && (e === null || typeof e > "u"),
    [t.text]: !!e,
    [t.autofocus]: u || typeof n < "u",
    [t["straight-borders"]]: d,
    [t.fullWidth]: i
  });
}
const U = b.forwardRef(function(e, l) {
  const {
    text: o = null,
    icon: s = null,
    title: f = "",
    type: d = "button",
    className: r = "",
    theme: u = "default",
    size: i = "normal",
    disabled: n = !1,
    straightCorners: x = !1,
    onClick: C = p,
    onMouseDown: g = p,
    onMouseUp: k = p,
    autofocus: m = !1,
    fullWidth: N = !1,
    tabIndex: h,
    ariaLabel: B = ""
  } = e, y = b.useMemo(() => I({
    text: o,
    icon: s,
    theme: u,
    size: i,
    disabled: n,
    straightCorners: x,
    className: r,
    autofocus: m,
    fullWidth: N,
    tabIndex: h
  }), [
    m,
    r,
    n,
    N,
    s,
    i,
    x,
    h,
    o,
    u
  ]), M = b.useCallback((W) => {
    n || C(W);
  }, [n, C]);
  return /* @__PURE__ */ c(
    "button",
    {
      ref: l,
      disabled: n,
      className: y,
      onClick: M,
      onMouseDown: g,
      onMouseUp: k,
      autoFocus: m,
      tabIndex: h,
      title: f,
      type: d,
      "aria-label": B,
      children: /* @__PURE__ */ c(F, { ...e })
    }
  );
});
export {
  U as Button,
  F as ButtonContent,
  I as getButtonClassName
};
